/**
 * Get the tool locales for the given language
 * @param lang - The language code
 * @returns The tool locales
 */
export function toolLocales(lang: string) {
  const isAr = lang === "ar";
  return {
    factSheet: isAr ? "arabic" : "english",
    standard: isAr ? "ar-ae" : "en-gb",
  };
}
